import request from "@/utils/request";

/**
 * 获取订单列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getOrderList(params) {
    return request({
        url: '/system/order/table',
        method: 'get',
        params
    })
}

/**
 * 获取订单详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getOrderDetail(params) {
    return request({
        url: '/system/order/detail',
        method: 'get',
        params
    })
}

/**
 * 订单还款
 * @returns {AxiosPromise}
 * @param payId
 */
export function orderRepay(payId) {
    return request({
        url: `/system/order/repayment/repay/${payId}`,
        method: 'put'
    })
}

/**
 * 订单取消
 * @returns {AxiosPromise}
 * @param payId
 */
export function orderCancel(orderNo) {
    return request({
        url: `/system/order/cancel/${orderNo}`,
        method: 'put'
    })
}


/**
 * 订单还款记录列表
 * @returns {AxiosPromise}
 * @param orderNo
 * @param status
 */
export function orderRepayList(orderNo, status = '') {
    return request({
        url: '/system/order-repayment/list',
        method: 'get',
        params: {
            orderNo: orderNo,
            status: status
        }
    })
}
/**
 * 打款
 * @returns {AxiosPromise}
 * @param data
 */
export function orderPay(data) {
    return request({
        url: `/system/order/payment/`,
        method: 'put',
        data
    })
}
/**
 * 归档
 * @returns {AxiosPromise}
 * @param data
 */
export function orderAchieve(data) {
    return request({
        url: `/system/order/archive/`,
        method: 'put',
        data
    })
}
/**
 * 结清
 * @returns {AxiosPromise}
 * @param data
 */
export function orderClear(params) {
    return request({
        url: `/system/order/clear/`,
        method: 'put',
        params: params
    })
}
